import Axios from 'axios';
import Resource from 'bol-rest/resource';
import displayApiError from '../modules/notifications/actions/displayApiError';

export const api = Axios.create({
    baseURL: '/api/v1',
});

api.interceptors.response.use(
    response => response,
    (error) => {
        if (error.constructor && error.constructor.name === 'Cancel') {
            return;
        }

        displayApiError({ props: { error } });
        throw error;
    }
);

export const Author = Resource(api, '/author');
export const User = Resource(api, '/user');
export const ReviewRevision = Resource(api, '/review/revision');
export const Review = Resource(api, '/review/requests', null, true);

export const ResourceForms = Resource(api, '/resource/forms');
export const ResourceSearch = Resource(api, '/resource/search');
export const ResourceTree = Resource(api, '/resource/tree');
export const ResourceLaw = Resource(api, '/resource/laws');
export const ResourceAnnotation = Resource(api, '/resource/annotations');
export const ResourceAnnotationGroups = Resource(
    api,
    '/resource/annotation-groups'
);
export const ResourcePageGroups = Resource(api, '/resource/page-groups');

export const ResourceArticle = Resource(api, '/resource/articles');
export const ResourcePseudoArticle = Resource(api, '/resource/pseudo_articles');
export const ResourceBook = Resource(api, '/resource/books');
export const ResourcePart = Resource(api, '/resource/parts');
export const ResourcePage = Resource(api, '/resource/pages');
export const ResourceChapter = Resource(api, '/resource/chapters');
export const ResourceInscription = Resource(api, '/resource/inscriptions');
export const ResourceTitle = Resource(api, '/resource/titles');
export const ResourceAttachment = Resource(api, '/resource/attachments');
export const ResourceNote = Resource(api, '/resource/notes');
export const ResourceDepartment = Resource(api, '/resource/departments');
export const ResourceSubdepartment = Resource(api, '/resource/subdepartments');
export const ResourceSection = Resource(api, '/resource/sections');
export const ResourceSubsection = Resource(api, '/resource/subsections');
export const ReviewSources = Resource(api, '/review/sources');

export const Publication = Resource(api, '/snapshot');
export const PublicationResource = Resource(api, '/snapshot-resource');
export const BackgroundProcess = Resource(api, '/background-process');
export const BackgroundChainProcess = Resource(api, '/background-chain');

export const PracticalDocuments = Resource(api, '/practical-documents');
export const PracticalDocumentCategories = Resource(
    api,
    '/practical-documents-types'
);
export const Themes = Resource(api, '/themes');
export const Sites = Resource(api, '/sites');
export const Words = Resource(api, '/words');

const resources = {
    forms: ResourceForms,
    search: ResourceSearch,
    tree: ResourceTree,
    laws: ResourceLaw,
    annotations: ResourceAnnotation,
    'annotation-groups': ResourceAnnotationGroups,
    'page-groups': ResourcePageGroups,
    articles: ResourceArticle,
    pseudo_articles: ResourcePseudoArticle,
    books: ResourceBook,
    parts: ResourcePart,
    pages: ResourcePage,
    chapters: ResourceChapter,
    inscriptions: ResourceInscription,
    titles: ResourceTitle,
    attachments: ResourceAttachment,
    notes: ResourceNote,
    departments: ResourceDepartment,
    subdepartments: ResourceSubdepartment,
    sections: ResourceSection,
    subsections: ResourceSubsection,
};

export default {
    authors: Author,
    resources,
    reviews: Review,
    reviewRevisions: ReviewRevision,
    reviewSources: ReviewSources,
    users: User,
    publications: Publication,
    publicationResources: PublicationResource,
    practicalDocuments: PracticalDocuments,
    sites: Sites,
    practicalDocumentCategories: PracticalDocumentCategories,
    themes: Themes,
    backgroundProcess: BackgroundProcess,
    backgroundChainProcess: BackgroundChainProcess,
    words: Words,
};



// WEBPACK FOOTER //
// ./resources/assets/admin/common/resources/index.js